import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Carousel from "react-grid-carousel";
import TrendsImg from "../Fokusthema/PptImages/trends.svg";
import DigitalImg from "../Fokusthema/PptImages/digital.svg";
import CompImg from "../Fokusthema/PptImages/competition.svg";
import BankImg from "../Fokusthema/PptImages/bank-euro.svg";
import BrainImg from "../Fokusthema/PptImages/brain.svg";
import VirImg from "../Fokusthema/PptImages/vir.svg";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import Marquee from "react-fast-marquee";

import {
	Grid,
	Card,
	CardContent,
	Box,
	CardMedia,
	TextField,
} from "@mui/material";
import Buisiness from "./images/Buisiness.jpg";
import gregor from "./images/gregor-produkt.png";
import kristin from "./images/kristin.png";
import markus from "./images/markus.png";
import BIcon1 from "./images/bottom_icon1.svg";
import BIcon2 from "./images/bottom_icon2.svg";
import BIcon3 from "./images/bottom_icon3.svg";
import BIcon4 from "./images/bottom_icon4.svg";
import downloadImg from "./images/download.svg";
import Icon1 from "./images/icon1.svg";
import Icon2 from "./images/icon2.svg";
import Icon3 from "./images/icon3.svg";
import Icon4 from "./images/icon4.svg";
import Icon5 from "./images/icon5.svg";
import Icon6 from "./images/icon6.svg";
import Icon7 from "./images/icon7.svg";
import Icon8 from "./images/icon8.svg";
import details_ansen from "./images/details_ansen.svg";
import check_circle from "./images/check_circle.svg";
// import Interim from "./images/Interim.jpg";
// import Effizienz from "./images/Effizienz.jpg";
// import Nachfolge from "./images/Nachfolge.jpg";
import Orga05 from "../Fokusthema/PptImages/org5.svg";
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
import "./digitalisierungs.css";
import { getReferences } from "../../Transformations/NewsList";
import FLoader from "../../Transformations/FLoader";
import bgDigit from "../../../images/beratungsfelder/bg.svg";
import ProducktFooter from "./ProducktFooter";
export default function Produkt() {
	const [referenceData, setReferenceData] = useState(null);
	const [activeSlide, setActiveSlide] = useState(0);

	const [scrollHdColor, setScrollHdColor] = useState("digitalisierungs-hd top");

	const [activeSlideIndex, setActiveSlideIndex] = useState(0);

	const [content, setContent] = useState("All");
	const [animationClass, setAnimationClass] = useState("fade-in");

	useEffect(() => {
		const fetchData = async () => {
			const data = await getReferences();
			setReferenceData(data);
		};

		const handleScroll = () => {
			const scrollPosition = window.scrollY;
			const threshold = 100;

			if (scrollPosition > threshold) {
				setScrollHdColor("digitalisierungs-hd top-not");
			} else {
				setScrollHdColor("digitalisierungs-hd top");
			}
		};

		fetchData();
		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	const scrollToSection = (sectionId) => {
		const element = document.getElementById(sectionId);
		if (element) {
			element.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	};

	useEffect(() => {}, [location.pathname]);

	const handleClick = (newContent) => {
		if (content !== newContent) {
			setAnimationClass("fade-out");
			setTimeout(() => {
				setContent(newContent);
				setAnimationClass("fade-in");
			}, 500); // Match the fade-out duration
		}
	};

	return (
		<div className="digitalisierungs-new-page">
			<HelmetProvider>
				<Helmet>
					<title>
						Digitalisierungs- und Prozessberatung für die Immobilienwirtschaft
					</title>
					<meta
						name="description"
						content="	Digitalisierungs- und Prozessberatung für die Immobilienwirtschaft"
					/>
					<meta
						name="keywords"
						content="Digitalisierungs, Prozessberatung, Immobilienwirtschaft, Feingeist, Berlin"
					/>
				</Helmet>
			</HelmetProvider>
			<div className="digitalisierungs_page bgDigit" id="digitalisierungs">
				{/* <div className="head-bg"> </div> */}
				<div className="digitalisierungs_content mt-0">
					<div className="page-top-custom">
						<div className="page-hd-custom">
							<h1>Prozesse digitalisieren</h1>
							<hr className="hd-divider" />
							<span className="sub-hd-custom">
								Als Immobilienverwaltung stoßen Sie wahrscheinlich regelmäßig
								auf mindestens eine dieser <b>Herausforderungen</b>:
							</span>
						</div>
					</div>
					<div className="digitalisierungs_sub px-4 bg-white">
						<div class="container my-5 p-4 box-container">
							<div class="row text-center">
								<div class="col-md-3 col-6 mb-4 feature-box-container">
									<div className="feature-box">
										<div class="icon mb-2">
											<img src={Icon1} />
										</div>
										<p>
											<strong>Fehlende strategische Ausrichtung</strong>
										</p>
									</div>
								</div>
								<div class="col-md-3 col-6 mb-4 feature-box-container">
									<div className="feature-box">
										<div class="icon mb-2">
											<img src={Icon2} />
										</div>
										<p>
											<strong>Keine Digitalisierungs-strategie</strong>
										</p>
									</div>
								</div>
								<div class="col-md-3 col-6 mb-4 feature-box-container">
									<div className="feature-box">
										<div class="icon mb-2">
											<img src={Icon3} />
										</div>
										<p>
											<strong>Nicht funktionierende oder keine Prozesse</strong>
										</p>
									</div>
								</div>
								<div class="col-md-3 col-6 mb-4 feature-box-container">
									<div className="feature-box">
										<div class="icon mb-2">
											<img src={Icon4} />
										</div>
										<p>
											<strong>Hohe Belastungsspitzen und Rückstand</strong>
										</p>
									</div>
								</div>
								<div class="col-md-3 col-6 mb-4 feature-box-container">
									<div className="feature-box">
										<div class="icon mb-2">
											<img src={Icon5} />
										</div>
										<p>
											<strong>
												Übergabe bzw. Nachfolge unklar bzw. nichtorganisiert
											</strong>
										</p>
									</div>
								</div>
								<div class="col-md-3 col-6 mb-4 feature-box-container">
									<div className="feature-box">
										<div class="icon mb-2">
											<img src={Icon6} />
										</div>
										<p>
											<strong>Unübersichtliche Messdienstleistungen</strong>
										</p>
									</div>
								</div>
								<div class="col-md-3 col-6 mb-4 feature-box-container">
									<div className="feature-box">
										<div class="icon mb-2">
											<img src={Icon7} />
										</div>
										<p>
											<strong>Kein Personal und hohe Fluktuation</strong>
										</p>
									</div>
								</div>
								<div class="col-md-3 col-6 mb-4 feature-box-container">
									<div className="feature-box">
										<div class="icon mb-2">
											<img src={Icon8} />
										</div>
										<p>
											<strong>Keine Begleitung bei der Digitalisierung</strong>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className={`digitalisierungs_sub px-4 `}>
						<div className="d-flex">
							<div className="page-body-custom">
								<span className="sub-body-custom">
									Für diese Herausforderungen bieten wir eine passgenaue Lösung
									an, die wir gemeinsam mit Ihnen umsetzen.
								</span>
								<h1>Unsere Lösungen</h1>
								{/* <hr className="hd-divider" /> */}
							</div>
						</div>
						<div className=""></div>
					</div>
					<div className="btns-hd-sub ">
						{/* <button
							className="hd-sub"
							onClick={(e) => {
								handleClick("All");
							}}
						>
							Alle
						</button> */}

						<button
							className="hd-sub"
							onClick={(e) => {
								scrollToSection("Orga");
							}}
						>
							Orga Check
						</button>
						<button
							className="hd-sub"
							onClick={(e) => {
								scrollToSection("Digitality");
							}}
						>
							Digitality Check
						</button>
						<button
							className="hd-sub"
							onClick={(e) => {
								scrollToSection("Buisiness");
							}}
						>
							Business Check
						</button>
						<button
							className="hd-sub"
							onClick={(e) => {
								scrollToSection("Interim");
							}}
						>
							Change-Management
						</button>
						<button
							className="hd-sub"
							onClick={(e) => {
								scrollToSection("Effizienz");
							}}
						>
							Scale Up Mentoring{" "}
						</button>
						{/* <button
							className="hd-sub"
							onClick={(e) => {
								handleClick("Nachfolge");
							}}
						>
							Nachfolge Check
						</button> */}
					</div>
					<div className={`digitalisierungs_sub px-4 row ${animationClass}`}>
						<div className="row py-4" id="Orga">
							<div className="col-md-6 img-cover-sub bg_box_Orga">
								<a
									className="product-details-download"
									href="https://feingeist-beratung.de/wp-content/uploads/2024/08/Das-Orga-Check-Konzept-der-Feingeist-Beratung.pdf"
								>
									<span className="details-prod-download">
										<img width="auto" height="120" src={details_ansen} />
									</span>
								</a>
							</div>
							<div className="col-md-5 sub-text-content">
								<div className="sub-hd-block pos-left-sub">
									<div className="sub-hd-text">
										<span>Orga Check</span>
									</div>
									<div className="sub-hd-desc d-flex flex-column">
										Mit unserem Orga Check optimieren Sie die Prozesse Ihrer
										Immobilienverwaltung. Wir analysieren Ihre aktuelle
										Prozesslandschaft, identifizieren Schwachstellen und
										erarbeiten Lösungen zur Effizienzsteigerung. So senken Sie
										Kosten, entlasten Ihre Mitarbeiter und erhöhen die
										Kundenzufriedenheit.
										<div className="row">
											<div className="col-md-6 py-2 p-0 point-checked">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Kosten senken
											</div>
											<div className="col-md-6 py-2 p-0 point-checked">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Kundenzufriedenheit heben
											</div>
											<div className="col-md-6 py-2 p-0 point-checked">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Neue Erlösquellen generieren
											</div>
											<div className="col-md-6 py-2 p-0 point-checked">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Mitarbeiter entlasten
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="row py-4" id="Buisiness">
							<div className="col-md-5 sub-text-content">
								<div className="sub-hd-block pos-right-sub">
									<div className="sub-hd-text">
										<span>Business Check</span>
									</div>
									<div className="sub-hd-desc">
										Unser Business Check hilft Ihnen, eine klare strategische
										Ausrichtung für Ihre Immobilienverwaltung zu entwickeln. Wir
										analysieren Ihre aktuelle Situation in fünf Kompetenzfeldern
										und erarbeiten individuelle Lösungsansätze. So sichern Sie
										die Zukunft Ihrer Verwaltung und steigern schnell Gewinn und
										Unternehmenswert.
										<br />
										<div className="row">
											<div className="col-md-12 py-2 p-0">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Zukunftssicherung Ihrer Verwaltung und Bestimmung
												der Ausrichtung
											</div>
											<div className="col-md-12 py-2 p-0">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Schnelle Steigerung von Gewinn und Wert Ihrer
												Verwaltung
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-6 img-cover-sub bg_box_Buisiness">
								<a
									className="product-details-download"
									href="https://feingeist-beratung.de/wp-content/uploads/2023/12/das_kennzahlen_cockpit_der_feingeist_gmbh.pdf"
								>
									<span className="details-prod-download">
										<img width="auto" height="120" src={details_ansen} />
									</span>
								</a>
							</div>
						</div>

						<div className="row py-4" id="Digitality">
							<div className="col-md-6 img-cover-sub bg_box_Digitality">
								<a
									className="product-details-download"
									href="https://feingeist-beratung.de/wp-content/uploads/2023/12/der_messdienst_check_der_feingeist_beratung.pdf"
								>
									<span className="details-prod-download">
										<img width="auto" height="120" src={details_ansen} />
									</span>
								</a>
							</div>
							<div className="col-md-5 sub-text-content">
								<div className="sub-hd-block pos-left-sub">
									<div className="sub-hd-text">
										<span>Digitality Check</span>
									</div>
									<div className="sub-hd-desc">
										Unser Digitality Check unterstützt Sie dabei, Ihre
										Immobilienverwaltung zukunftssicher zu machen. Gemeinsam
										analysieren wir Ihre aktuelle Situation in fünf Dimensionen,
										identifizieren Herausforderungen und entwickeln eine
										maßgeschneiderte Digitalstrategie. So schaffen Sie klare
										Strukturen, optimieren Prozesse und erschließen neue
										Einnahmequellen.
										<div className="row">
											<div className="col-md-12 py-2 p-0">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Entwicklung einer Digitalstrategie
											</div>
											<div className="col-md-12 py-2 p-0">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Bestimmung der zukünftigen Ausrichtung im
												digitalen Wandel
											</div>
											<div className="col-md-12 py-2 p-0">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Neue Erlösquellen erschließen und Potentiale
												heben
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="row py-4" id="Interim">
							<div className="col-md-5 sub-text-content">
								<div className="sub-hd-block pos-right-sub">
									<div className="sub-hd-text">
										<span>Change-Management</span>
									</div>
									<div className="sub-hd-desc">
										Unser Change-Management bietet Ihnen kurzfristige
										Unterstützung bei Engpässen und Rückständen in Ihrer
										Immobilienverwaltung. Erfahrene Mitarbeiter übernehmen
										zeitkritische Projekte, erstellen Maßnahmenpläne und sorgen
										für eine schnelle Umsetzung, um Belastungsspitzen effizient
										abzuarbeiten.
										<div className="row">
											<div className="col-md-12 py-2 p-0">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Belastungsspitzen abarbeiten
											</div>
											<div className="col-md-12 py-2 p-0">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Neue Erlösquellen erschließen und Potentiale
												heben
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-6 img-cover-sub bg_box_Interim">
								{" "}
								<a
									className="product-details-download"
									href="https://feingeist-beratung.de/wp-content/uploads/2023/12/interim-management_der_feingeist_beratung.pdf"
								>
									<span className="details-prod-download">
										<img width="auto" height="120" src={details_ansen} />
									</span>
								</a>
							</div>
						</div>

						<div className="row py-4" id="Effizienz">
							<div className="col-md-6 img-cover-sub bg_box_ScaleUp">
								<a
									className="product-details-download"
									href="https://feingeist-beratung.de/wp-content/uploads/2024/12/Scale-up-der-Feingeist-GmbH.pdf"
								>
									<span className="details-prod-download">
										<img width="auto" height="120" src={details_ansen} />
									</span>
								</a>
							</div>
							<div className="col-md-5 sub-text-content">
								<div className="sub-hd-block pos-left-sub">
									<div className="sub-hd-text">
										<span>Scale Up Mentoring</span>
									</div>
									<div className="sub-hd-desc">
										Mit unserem Effizienz Check - Cockpit erhalten Sie ein
										maßgeschneidertes Kennzahlen-Dashboard, das Ihre
										Unternehmensleistung auf einen Blick darstellt. Wir
										analysieren werttreibende Größen, vergleichen Ihre
										Kennzahlen mit der Branche und leiten Maßnahmen zur
										Verbesserung der Unternehmenssteuerung ab. So erkennen Sie
										Schwachstellen und optimieren Ihre strategische Ausrichtung.
										<div className="row">
											<div className="col-md-12 py-2 p-0">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Darstellung der Unternehmensleistung durch ein
												Kennzahlensystem auf einem Blick
											</div>
											<div className="col-md-12 py-2 p-0">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Verbesserung der Unternehmenssteuerung
											</div>
											<div className="col-md-12 py-2 p-0">
												<img height="20" width="auto" src={check_circle} />{" "}
												&nbsp; Erkennung von Schwachstellen zur Verbesserung der
												strategischen Ausrichtung
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="digitalisierungs_sub px-4 row">
						<div className="col-md-12 body-end row">
							<div className="page-body-end-custom col-md-12 ">
								<h1>Wir lassen Sie nicht alleine</h1>
								<div className="team-photo w-100">
									<div className="team-photo-col d-flex w-100">
										<div className="team-photo-round">
											<img height="70%" width="auto" src={kristin} />
										</div>
										<div className="team-photo-round">
											<img height="70%" width="auto" src={markus} />
										</div>
										<div className="team-photo-round">
											<img height="70%" width="auto" src={gregor} />
										</div>
									</div>
								</div>
								<span className="sub-body-custom team-text">
									Unsere Checks sind nur der erste Schritt. Für die vollständige
									operative Umsetzung steht Ihnen unsere Unternehmensberatung
									zur Seite. Ob vor Ort oder aus der Ferne – unsere Experten
									begleiten Sie persönlich durch den gesamten Prozess und sorgen
									für eine reibungslose Umsetzung. Ihre individuelle Betreuung
									ist unser Alleinstellungsmerkmal.
								</span>
							</div>

							<div className="steps-three-product">
								<div className="steps">
									<div className="step">
										<div className="circle">01</div>
										<div className="line"></div>
										<div className="description">
											<p>
												Unsere Checks sind nur der erste Schritt. <br />
												Für die{" "}
												<strong>vollständige operative Umsetzung</strong> steht
												Ihnen unsere Unternehmensberatung zur Seite.
											</p>
										</div>
									</div>
									<div className="step">
										<div className="circle">02</div>
										<div className="line"></div>
										<div className="description">
											<p>
												Unsere Checks sind nur der erste Schritt. <br />
												Für die{" "}
												<strong>vollständige operative Umsetzung</strong> steht
												Ihnen unsere Unternehmensberatung zur Seite.
											</p>
										</div>
									</div>
									<div className="step">
										<div className="circle">03</div>
										<div className="description">
											<p>
												Unsere Checks sind nur der erste Schritt. <br />
												Für die{" "}
												<strong>vollständige operative Umsetzung</strong> steht
												Ihnen unsere Unternehmensberatung zur Seite.
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="features-container">
								<p className="features-title">
									Feingeist ist die richtige Wahl, weil wir Ihre{" "}
									<strong>Herausforderungen</strong>
									<br />
									verstehen und individuell <strong>
										passende Lösungen
									</strong>{" "}
									bieten.
								</p>
								<div className="features">
									<div className="feature">
										<div className="feature-icon">
											<img src={BIcon1} />
										</div>
										<p className="feature-title">
											Tiefgehende
											<br />
											<strong>Branchenkenntnis</strong>
										</p>
									</div>
									<div className="feature">
										<div className="feature-icon">
											<img src={BIcon2} />
										</div>
										<p className="feature-title">
											Maßgeschneiderte
											<br />
											<strong>Analysetools</strong>
										</p>
									</div>
									<div className="feature">
										<div className="feature-icon">
											<img src={BIcon3} />
										</div>
										<p className="feature-title">
											Umfangreiche
											<br />
											<strong>Projekterfahrung</strong>
										</p>
									</div>
									<div className="feature">
										<div className="feature-icon">
											<img src={BIcon4} />
										</div>
										<p className="feature-title">
											Synergieeffekte für
											<br />
											<strong>Effizienz</strong>
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="digitalisierungs_sub px-4">
						<div className="field-hd">
							<h2>Referenzen</h2>
						</div>

						{referenceData ? (
							<Carousel cols={3} rows={2} gap={10} showDots loop>
								{referenceData.map((reference, index) => {
									return (
										<Carousel.Item key={index}>
											<div className="text-center w-auto carousel-cont w-100 justify-content-center">
												<img className="carousel-img" src={reference.logo} />
											</div>
										</Carousel.Item>
									);
								})}
							</Carousel>
						) : (
							<FLoader />
						)}
					</div>
				</div>
			</div>
			<ProducktFooter />
		</div>
	);
}
